import { useContext } from 'react';

import { InAppNotificationContext } from './InAppNotificationProvider';

const useInAppNotification = () => {
  const context = useContext(InAppNotificationContext);

  if (!context) {
    throw new Error(
      'useInAppNotification must be used within a InAppNotificationProvider',
    );
  }

  return context;
};

export default useInAppNotification;
